import React, {useEffect, useState} from 'react'
import api from "../../api";
import {Alert, Button, Card, Col, Form, Input, message, Radio, Row, Select, Spin} from "antd";
import {printPrice} from "../../helpers";
import {DATE_FORMAT, DEFAULT_GUTTER} from "../../constants";
import CdnImage from "../../Components/CdnImage";
import AddressAutoComplete from "../../Components/AddressAutoComplete";
import ProfileHeader from "../../Components/ProfileHeader";
import {useParams} from "react-router-dom";
import {ArrowLeftOutlined} from "@ant-design/icons";
import dayjs from "dayjs";

export default function Cart() {

    const {slug} = useParams()
    const cartFromStorage = localStorage.getItem('cart')
    const [cart, setCart] = useState(cartFromStorage ? JSON.parse(cartFromStorage) : {});
    const [address, setAddress] = useState("");
    const [company, setCompany] = useState(null)
    const [form] = Form.useForm();
    const [pickUpSlots, setPickUpSlots] = useState([]);
    const [showPickupSlots, setShowPickupSlots] = useState(false);
    const [deliveryCosts, setDeliveryCosts] = useState({"price": 0, "status": "pending"});
    const [showDeliveryCosts, setShowDeliveryCosts] = useState(false);

    useEffect(() => {
        if (company && company.id) {
            api.getPickUpSlots(company.id).then(setPickUpSlots)
        }
    }, [company]);

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cart))
    }, [cart]);

    function calculateDeliveryCosts(lat, lng) {
        setDeliveryCosts({"price": 0, "status": "pending", "error": false});
        api.calculateDeliveryCosts(company.id, lat, lng).then((costs) => {
            setDeliveryCosts(costs);
        }).catch(() => {
            message.error("Er ging iets mis bij het berekenen van de bezorgkosten. Probeer het later opnieuw.");
        });
    }

    function remove(offer) {
        const newCart = {...cart};
        if (newCart[offer.id]) {
            delete newCart[offer.id];
        }
        setCart(newCart);
    }

    useEffect(() => {
        const offerIds = Object.keys(cart);
        if (offerIds.length > 0) {
            api.getOffersByIds(offerIds).then((offers) => {
                const newCart = {...cart};
                offers.forEach((offer) => {
                    newCart[offer.id] = {
                        ...newCart[offer.id],
                        ...offer
                    }
                });
                setCart(newCart);
            });
        }

        api.getCompanyBySlug(slug).then(setCompany)
    }, []);

    function createOrder() {

        const delivery_method = form.getFieldValue('delivery_method')
        if (delivery_method === "delivery" && deliveryCosts.error) {
            message.error("Er zijn geen bezorgkosten berekend. Zorg ervoor dat je een adres hebt ingevuld.");
            return;
        }


        api.createOrder({
            company_id: company.id,
            payment_method: form.getFieldValue('payment_method') || 'ideal',
            name: form.getFieldValue('name'),
            email: form.getFieldValue('email'),
            phone: form.getFieldValue('phone'),
            delivery_method: form.getFieldValue('delivery_method'),
            pick_up_date_time: form.getFieldValue('pick_up_date_time'),
            address,
            lines: Object.values(cart).map((offer) => {
                return {
                    offer_id: offer.id,
                    quantity: offer.quantity
                }
            })
        }).then((url) => {
            document.location = url
        }).catch((error) => {
            message.error("Er ging iets mis bij het plaatsen van je bestelling. Controleer of je alles hebt ingevuld en probeer het opnieuw.");
        })
    }


    function generateUpcomingTimeSlotStrings(slotDefs, lookaheadDays = 14) {
        const today = dayjs().startOf('day');
        const result = [];

        for (let i = 1; i < lookaheadDays; i++) {
            const date = today.add(i, 'day');
            const jsDay = date.day();
            const pythonDay = (jsDay + 6) % 7;

            slotDefs.forEach(slot => {
                if (slot.day_of_week === pythonDay) {
                    const dateStr = date.format(DATE_FORMAT);
                    const start = String(slot.starts_at).padStart(2, '0') + ':00';
                    const end = String(slot.ends_at).padStart(2, '0') + ':00';
                    result.push(`${dateStr} ${start} - ${end}`);
                }
            });
        }

        return result;
    }

    const cartList = Object.values(cart);

    const cartTotal = cartList.reduce((total, offer) => {
        return total + (offer.price * offer.quantity);
    }, 0);

    if (!company) {
        return <Spin/>
    }

    if (!cartList || cartList.length === 0) {
        return (
            <div>
                <ProfileHeader company={company}></ProfileHeader>
                <Card style={{background: 'white'}}>
                    <h1>Je winkelmandje is leeg</h1>
                    <p>Je kunt producten toevoegen aan je winkelmandje door naar de <a
                        href={`/${slug}`}>aanbiedingen</a> te gaan.</p>
                </Card>
            </div>
        )
    }

    return (
        <div>

            <ProfileHeader company={company}></ProfileHeader>
            <Button size={"large"} type={"link"} className={"mar-b-1"} href={`/${slug}`}>
                <ArrowLeftOutlined/> Terug
            </Button>
            <Form layout={"vertical"} form={form}>
                <Row gutter={DEFAULT_GUTTER}>
                    <Col md={12} xs={24}>
                        <Card style={{background: 'white'}}>
                            <h1>Jouw gegevens</h1>
                            <Form.Item label={"Naam"} name={"name"}>
                                <Input/>
                            </Form.Item>
                            <Row gutter={DEFAULT_GUTTER}>
                                <Col span={12}>
                                    <Form.Item label={"E-mailadres"} name={"email"}>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label={"Telefoonnummer"} name={"phone"}>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item label={"Adres"}>
                                <AddressAutoComplete value={address} onSelect={(e) => {
                                    calculateDeliveryCosts(e.geometry.location.lat(), e.geometry.location.lng())
                                    setAddress(e.formatted_address || e.name);
                                }}/>
                                {showDeliveryCosts && deliveryCosts.status === "error" && (
                                    <Alert className={"mar-t-1"} type={"error"} description={(<>Sorry we bezorgen hier niet.</>)}></Alert>
                                )}
                            </Form.Item>
                            <h1>Levering</h1>
                            <Form.Item name={"delivery_method"}>
                                <Radio.Group onChange={(e) => {
                                    setShowPickupSlots(e.target.value === 'pickup_slot');
                                    setShowDeliveryCosts(e.target.value === 'delivery');
                                }}>
                                    {company.is_on_appointment_enabled && (
                                        <Radio value={"appointment"} style={{display: 'block'}}>Afhalen op
                                            afspraak</Radio>
                                    )}

                                    {company.is_stall_enabled && (
                                        <Radio value={"stall"} style={{display: 'block'}}>Pakken uit de kraam</Radio>
                                    )}
                                    {company.is_pickup_enabled && (
                                        <>
                                            <Radio value={"pickup_slot"} style={{display: 'block'}}>
                                                Afhaalmoment kiezen
                                            </Radio>
                                        </>
                                    )}

                                    {company.is_delivery_enabled && (
                                        <>
                                            <Radio value={"delivery"} style={{display: 'block'}}>
                                                Laten bezorgen
                                            </Radio>
                                        </>
                                    )}

                                </Radio.Group>
                            </Form.Item>
                            <Form.Item name={"pick_up_date_time"}>
                                {showPickupSlots && (
                                    <Select placeholder={"Kies een afhaalmoment"} style={{width: '100%'}}>
                                        {generateUpcomingTimeSlotStrings(pickUpSlots).map((slot) => (
                                            <Select.Option
                                                key={slot}>
                                                {slot}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Card>
                    </Col>
                    <Col md={12} xs={24}>

                        <Card style={{background: 'white'}} className={"cart"}>
                            <h1>Besteloverzicht</h1>
                            {cartList.map((offer) => (
                                <Row gutter={DEFAULT_GUTTER} id={offer.id} style={{borderBottom: 'solid 1px silver'}}
                                     className={"pad-1"}>
                                    <Col md={2} xs={24}>
                                        <CdnImage src={offer.image} width={250} height={250} style={{
                                            borderRadius: '10px',
                                            width: '100%',
                                            objectFit: 'cover',
                                            objectPosition: 'center'
                                        }}></CdnImage>
                                    </Col>
                                    <Col md={16} xs={24}>
                                        <h2>{offer.quantity}x {offer.title}</h2>
                                    </Col>
                                    <Col md={6} className={"text-right"} xs={24}>
                                        <h3>{printPrice(offer.price * offer.quantity)}</h3>
                                        <Button type={"link"} style={{padding: 0, marign: 0}}
                                                onClick={() => remove(offer)}
                                                danger>Verwijder</Button>
                                    </Col>
                                </Row>
                            ))}

                            {showDeliveryCosts && (
                                <Row className={"pad-1"}>
                                <Col md={18} xs={24}>
                                    <h3>Bezorgkosten</h3>
                                    <p>{company.delivery_instructions}</p>
                                </Col>
                                <Col md={6} xs={24} className={"text-right"}>
                                    {deliveryCosts.status === "pending" ? <Spin /> : null}
                                    {deliveryCosts.status === "ok" ? <h3>{printPrice(deliveryCosts.price)}</h3> : null}
                                    {deliveryCosts.status === "error" ? <h3>We bezorgen hier niet :(</h3> : null}
                                </Col>
                            </Row>
                            )}


                            <Row gutter={DEFAULT_GUTTER} className={"pad-1"}>
                                <Col md={18} xs={24}>
                                    <h3>Transactiekosten</h3>
                                    <p>Dit zijn kosten die Oogst.app rekent voor het afhandelen van de betaling,
                                        administratie en het online houden van deze software :)</p>
                                </Col>
                                <Col md={6} className={"text-right"} xs={24}>
                                    <h3>{printPrice(1)}</h3>
                                </Col>
                            </Row>
                            <Row gutter={DEFAULT_GUTTER} className={"pad-1"}>
                                <Col xs={12} md={18}>
                                    <h1>Totaal</h1>
                                </Col>
                                <Col xs={12} md={6} className={"text-right"}>
                                    <h1>{printPrice(cartTotal + 1 + deliveryCosts.price)}</h1>
                                </Col>
                            </Row>

                            <Row gutter={DEFAULT_GUTTER}>
                                <Col span={24}>
                                    <p>We gebruiken Mollie om betalingen te verwerken. Dit is veilig en betrouwbaar. Je
                                        kunt
                                        betalen met iDEAL, Bancontact en Credit Card</p>

                                    <Form.Item>
                                        <Button disabled={deliveryCosts.status === "error"} type={"primary"} size={"large"} block onClick={() => {
                                            createOrder()
                                        }}>Betaal nu</Button>
                                    </Form.Item>
                                    <p>Oogst.app faciliteert enkel de betaling en is niet verantwoordelijk voor de
                                        kwaliteit, levering of verdere
                                        afhandeling van de bestelling. Let op: bij een retour of annulering worden de
                                        transactiekosten niet teruggestort.</p>

                                </Col>
                            </Row>

                        </Card>
                    </Col>
                </Row>

            </Form>
        </div>
    )
}